module.exports = __webpack_public_path__ + "media/images/demo/login-38c0e6db62705048144f9353c3fa8d5d.jpg";